import React from "react";
import { MapContainer, Marker, Popup, TileLayer } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import L from "leaflet";
const index = ({
  position = "36.258241314877736,58.83325211656804",
  style = {},
  title = "نیکوتن | همراه همیشگی سلامت",
}) => {
  var greenIcon = L.icon({
    iconUrl: window.origin + "/img/icons/location.png",
    iconSize: [40, 40], // size of the icon
    popupAnchor: [0, 0],
    alt: "لوکیشن", // point from which the popup should open relative to the iconAnchor
  });
  const pos = position.split(",");
  return (
    <MapContainer
      center={pos}
      zoom={15}
      scrollWheelZoom={false}
      style={{ ...style }}
    >
      <TileLayer
        attribution='&copy; <a href="https://www.nikotan.ir">Nikotan</a>'
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      />
      <Marker position={pos} icon={greenIcon} alt="لوکیشن">
        <Popup>{title}</Popup>
      </Marker>
    </MapContainer>
  );
};

export default index;
